import { render } from "./LocationConfirmation.vue?vue&type=template&id=6d39d0c0&scoped=true"
import script from "./LocationConfirmation.vue?vue&type=script&lang=js"
export * from "./LocationConfirmation.vue?vue&type=script&lang=js"

import "./LocationConfirmation.vue?vue&type=style&index=0&id=6d39d0c0&lang=scss&scoped=true"

import exportComponent from "/home/forge/staging-logistic.hoornbloommasters.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d39d0c0"]])

export default __exports__